// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"175":"35a872e4310dbc057279","231":"26ec352baaf3798a6430","503":"0c469d30e60ec92034a6","678":"021f0550bbdf8ae6bcc9","883":"39c60e9cbc9ef56f5a05"}[chunkId] + ".js";
};